var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  min-height: 30px;\n  align-items: center;\n  font-weight: 500;\n  flex-direction: ', ';\n  text-align: center;\n  @media (max-width: 1024px) {\n    flex-direction: ', ';\n    display: flex;\n    text-align: center;\n    width: 100%;\n  }\n  &.column {\n    flex-direction: column;\n    padding-bottom: 8px;\n  }\n  &.row {\n    @media (max-width: 1024px) {\n      flex-direction: row;\n    }\n    @media (max-width: 375px) {\n      flex-direction: column;\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  min-height: 30px;\n  align-items: center;\n  font-weight: 500;\n  flex-direction: ', ';\n  text-align: center;\n  @media (max-width: 1024px) {\n    flex-direction: ', ';\n    display: flex;\n    text-align: center;\n    width: 100%;\n  }\n  &.column {\n    flex-direction: column;\n    padding-bottom: 8px;\n  }\n  &.row {\n    @media (max-width: 1024px) {\n      flex-direction: row;\n    }\n    @media (max-width: 375px) {\n      flex-direction: column;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Row = styled.div(_templateObject, function (props) {
  return props.vertical ? 'column' : 'row';
}, function (props) {
  return props.withButtonGroup ? 'column' : 'row';
});

var QQRow = function QQRow(props) {
  var vertical = props.vertical,
      withButtonGroup = props.withButtonGroup;
  return React.createElement(Row, {
    vertical: vertical,
    withButtonGroup: withButtonGroup
  }, props.children);
};

export default QQRow;